import { P2GBox, P2GFade, P2GLink } from '@parcel2go/core-ui';
import { ReactNode, Suspense, useState } from 'react';
import { P2GSidePanel } from '~/components/sidepanel';
import PrePayList from './prepay-list';
import PrePayTopup from './prepay-topup';

const PrePayQuickList = ({ label, title }: { label: string | ReactNode; title: string }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {typeof label === 'string' ? (
        <P2GLink onClick={() => setOpen(true)}>{label}</P2GLink>
      ) : (
        <P2GBox onClick={() => setOpen(true)}>{label}</P2GBox>
      )}
      <P2GSidePanel open={open} onClose={() => setOpen(false)} anchor="right" width="500px" title={title}>
        {open && (
          <Suspense>
            <P2GBox display="flex" flexDirection="column" gap={2}>
              <PrePayTopup surface="sidebar" />
              <PrePayList
                take={5}
                wrapper={(x) => (
                  <P2GFade in timeout={1500}>
                    <>{x}</>
                  </P2GFade>
                )}
              />
            </P2GBox>
          </Suspense>
        )}
      </P2GSidePanel>
    </>
  );
};

export default PrePayQuickList;
